import React, { useContext, useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Button, Row, Col, Grid, Typography } from "antd";
import { BrowserRouter } from "react-router-dom";
import { LoginContext } from "../components/seguridad/servicios/LoginServicios";
import UsuarioDropdown from "../generales/SessionDropdown";
import RoutersSystem from "./Routers";
import MenuPrincipal from "../generales/MenuPricipal";
import { useTranslation } from "react-i18next";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;
const { Text } = Typography;

const Home = () => {
  const { logout } = useContext(LoginContext);
  const { i18n } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const screens = useBreakpoint();

  if (
    !sessionStorage.getItem("idusuario") ||
    !sessionStorage.getItem("token") ||
    !sessionStorage.getItem("info_user")
  ) {
    logout();
  }

  // // Cambiar el idioma
  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  //   sessionStorage.setItem("idioma", lng);
  // };

  useEffect(() => {
    const userLang =
      sessionStorage.getItem("idioma") ||
      navigator.language ||
      navigator.userLanguage;
    const preferredLang = userLang.startsWith("es") ? "es" : "en";
    i18n.changeLanguage(preferredLang);
    sessionStorage.setItem("idioma", preferredLang);
  }, [i18n]);

  return (
    <BrowserRouter>
      <Layout style={{
        minHeight: "100vh",
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
      }}>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            background: 'linear-gradient(180deg, #0f1960 0%, #253289 50%, #1a237e 100%)',
            boxShadow: '4px 0 12px rgba(0, 0, 0, 0.15)',
            zIndex: 1000
          }}
          width={collapsed ? 80 : 240}
        >
          <MenuPrincipal collapsed={collapsed} />
        </Sider>
        <Layout>
          <Header
            className="header-layout"
            style={{
              background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
              padding: screens.md ? "0 32px" : "0 16px",
              boxShadow: '0 2px 12px rgba(37, 50, 137, 0.15)',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              zIndex: 999
            }}
          >
            <Row
              justify="space-between"
              align="middle"
              style={{ height: "100%" }}
              wrap={false}
            >
              <Col>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px'
                }}>
                  <Button
                    type="text"
                    icon={
                      collapsed ? (
                        <MenuUnfoldOutlined style={{ color: "#FFFFFF", fontSize: '18px' }} />
                      ) : (
                        <MenuFoldOutlined style={{ color: "#FFFFFF", fontSize: '18px' }} />
                      )
                    }
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '12px',
                      height: "48px",
                      width: "48px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  {screens.md && (
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <Text style={{
                        color: 'white',
                        fontSize: '20px',
                        fontWeight: '600',
                        margin: 0,
                        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                      }}>
                        Smart Delivery
                      </Text>
                      <Text style={{
                        color: 'rgba(255,255,255,0.8)',
                        fontSize: '12px',
                        margin: 0,
                        lineHeight: 1
                      }}>
                        Sistema de Gestión
                      </Text>
                    </div>
                  )}
                </div>
              </Col>
              <Col
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  padding: '8px 16px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <UsuarioDropdown />
                </div>
              </Col>
            </Row>
          </Header>
          <Content
            style={{
              minHeight: "calc(100vh - 64px)",
              background: 'transparent',
              padding: screens.md ? "24px" : "16px",
              position: 'relative'
            }}
          >
            {/* Background Pattern for Content */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `
                radial-gradient(circle at 20% 20%, rgba(37, 50, 137, 0.03) 0%, transparent 50%),
                radial-gradient(circle at 80% 80%, rgba(74, 90, 207, 0.02) 0%, transparent 50%),
                linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.01) 50%, transparent 70%)
              `,
              pointerEvents: 'none',
              zIndex: 0
            }} />

            <div style={{
              position: 'relative',
              zIndex: 1,
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: '16px',
              minHeight: 'calc(100vh - 112px)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              padding: screens.md ? "24px" : "16px"
            }}>
              <RoutersSystem />
            </div>
          </Content>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
};

export default Home;
